var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-flex-grid',{attrs:{"title":_vm.$t('Catalogues.DaySchedule.NameSingle'),"url-path":_vm.$api.catalogues.daySchedule,"edit-dialog":_vm.editDialog,"sortable":"","show400Error":""}})}
var staticRenderFns = []

export { render, staticRenderFns }